import React from 'react'
import RightHandSide from '../../Common/Services/RightHandSide'
import AboutInnBanContent from '../../Common/InnerBanner/AboutInnBanContent';
import { AboutInnerBanner } from '../../Common/InnerBanner/AboutInnerBanner';
import HeadContent from '../BlogContent/HeadContent';
import HeadDesign from '../BlogContent/HeadDesign';
import Info from '../BlogContent/Info';
import List from '../BlogContent/List';
import InfoContent from '../BlogContent/InfoContent';
import ListContent from '../BlogContent/ListContent';
import RecentBlogsList from '../BlogContent/RecentBlogsList';
import { Helmet } from 'react-helmet';


const Blog19 = () => {
    const {image, heading, pageName} = AboutInnBanContent.BlogDetails;
    const {bg, para, date, blogHeading} = HeadContent.blog_19;

    const {title, p} = InfoContent.Blog_19.one;
    const {title2, p2} = InfoContent.Blog_19.two;
    const {title3, p3} = InfoContent.Blog_19.three;
    const {title4, p4} = InfoContent.Blog_19.four;
    const {title5, p5} = InfoContent.Blog_19.five;
    const {title6, p6} = InfoContent.Blog_19.six;
    const {title7, p7} = InfoContent.Blog_19.seven;
    const {title8, p8} = InfoContent.Blog_19.eight;
    const {Ctitle, Cp} = InfoContent.Blog_19.conclusion;
    const {title9, p9} = InfoContent.Blog_19.nine;

    const {liss1} = ListContent.Blog_19.L1;
    const {liss2} = ListContent.Blog_19.L2;
    const {liss3} = ListContent.Blog_19.L3;
    const {liss4} = ListContent.Blog_19.L4;
  return (
    <>

        <Helmet>
            <title>
               Best IVF Center in Mumbai | Trusted Fertility Experts 2026
            </title>

            <meta
                name="description"
                content="IVF Center in Mumbai offering advanced fertility care in Chembur. Boost success rates with expert treatment. Book your consultation today."
            />

            <meta
                name="keywords"
                content="IVF Center in Mumbai, ivf clinic chembur, best fertility clinic in Mumbai, infertility treatment Mumbai, IVF specialist Mumbai, fertility hospital Mumbai, IVF success rate Mumbai, affordable IVF Chembur"
            />

            <link
                rel="canonical"
                href="https://www.acmefertility.com/19/BlogDetails"
            />
             {/* Article Schema */}
    <script type="application/ld+json">
        {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Article",
            "headline": "7 Powerful Reasons to Choose an IVF Center in Mumbai for Successful Parenthood (2026)",
            "description": "Complete guide to choosing the best IVF Center in Mumbai and Chembur with success tips and expert insights.",
            "author": {
                "@type": "Person",
                "name": "Acme Fertility"
            },
            "publisher": {
                "@type": "Organization",
                "name": "Acme Fertility"
            },
            "datePublished": "2026-06-16"
        })}
    </script>

    {/* Author Schema */}
    <script type="application/ld+json">
        {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Person",
            "name": "Acme Fertility",
            "description": "Fertility experts specializing in IVF and reproductive health with proven success rates."
        })}
    </script>

    {/* FAQ Schema */}
    <script type="application/ld+json">
        {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
                {
                    "@type": "Question",
                    "name": "What is the success rate of IVF in Mumbai?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "IVF success rates in Mumbai typically range between 40% to 60%, depending on age and medical condition."
                    }
                },
                {
                    "@type": "Question",
                    "name": "How much does IVF cost in Chembur?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "IVF treatment in Chembur can cost between ₹1.2 lakh to ₹2.5 lakh per cycle, depending on the clinic and treatment plan."
                    }
                },
                {
                    "@type": "Question",
                    "name": "How do I choose the best fertility clinic in Mumbai?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Look for success rates, doctor experience, advanced technology, and patient reviews when choosing a clinic."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Is IVF safe?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Yes, IVF is a safe and widely used procedure when performed by experienced fertility specialists."
                    }
                }
            ]
        })}
    </script>
        </Helmet>

        

    <AboutInnerBanner image={image} heading={heading} pageName={pageName} />

    <div className="blog-area pt-100 pb-70">
        <div className="container">
            <div className="row">
                <div className="col-lg-8">
                    <HeadDesign bg={bg} para={para} date={date} blogHeading={blogHeading} />
                    <Info title={title} p={p} />
                    <Info title={title2} p={p2} />
                    {/* <List liss={liss1} /> */}
                    <Info title={title3} p={p3} />
                    <List liss={liss1} />
                    <Info title={title4} p={p4} />
                    <Info title={title5} p={p5} />
                    
                    {/* <Info title={title5} p={p5} /> */}
                    <Info title={title6} p={p6} />
                    <List liss={liss2} />
                    <Info title={title7} p={p7} />
                     <Info title={title8}p={p8}/>
                     <List liss={liss3} />
                     <Info title={Ctitle} p={Cp} />
                     <Info title={title9} p={p9} />

                    
             </div>

                <div className="col-lg-4">
                    <RecentBlogsList/>
                    <RightHandSide/>
                </div>
            </div>
        </div>
    </div>

    </>
  )
}

export default Blog19